import { apiClient, Auth } from '@/shared/api'

export enum ActionType {
  PAY = 'PAY',
  CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT',
  DEPOSIT_RETURN_ACCOUNT = 'DEPOSIT_RETURN_ACCOUNT',
  RECEIPT_INFO = 'RECEIPT_INFO',
}

export type GuestNotification = {
  title: string
  content: string
  actionType: ActionType
  actionDescription: string
  contractId: number
  nowTime: string
  notificationTime: string
  deadlineTime: string | null
  deadlineDescription: string | null
}

export const getNotifications = async () => {
  const { data } = await apiClient.get<GuestNotification[]>({
    endpoint: '/guest/contracts/notifications',
    auth: Auth.REQUIRED,
  })

  return data
}
